import { render, staticRenderFns } from "./EventViewPage.vue?vue&type=template&id=130a9757"
import script from "./EventViewPage.vue?vue&type=script&lang=js"
export * from "./EventViewPage.vue?vue&type=script&lang=js"
import style0 from "./EventViewPage.vue?vue&type=style&index=0&id=130a9757&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports